module.exports = __webpack_public_path__ + "static/img/12areaB_04.a78b591.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_04.png
// module id = 1096
// module chunks = 1